import * as React from 'react';

interface CellProps {
    width: string;
    noSpacing?: boolean;
}

export const Cell: React.FC<CellProps> = ({ width, children, noSpacing = false }) => (
    <div className={`cell cell-${width} ${noSpacing ? 'no-spacing' : ''}`}>
        {children}
    </div>
);
